import { DateTools } from '@treezor/design-system';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

import { APP_VERSION, APP_BUILD } from '@/appVersion';

interface IFooterProps {
  isOpen?: boolean;
}

export function SidebarFooter({ isOpen }: IFooterProps) {
  const config = useDashboardConfig();

  return (
    <>
      {isOpen ? (
        <div className="flex flex-col items-center justify-center">
          <span data-testid="footer-dashboard-version-environment">
            {`${config?.site.name} - ${config?.site.environment}`}
          </span>
          <span data-testid="footer-dashboard-version-environment-version">{`v${APP_VERSION} (Build ${APP_BUILD})`}</span>
          <span data-testid="footer-dashboard-version-environment-year">
            {`© ${DateTools.format(DateTools.now(), 'year')}`}
          </span>
        </div>
      ) : (
        <span data-testid="footer-dashboard-version-environment">v{APP_VERSION}</span>
      )}
    </>
  );
}
